import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { ITooltipOption } from '../KubitTooltip/globalTooltips';
import InformationalTooltip from '../InformationalTooltip';
import { theme } from '../../styles/theme';

interface IProps {
  heading: string;
  tooltipOption?: ITooltipOption;
  children?: ReactNode;
}

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const HeadingContainer = styled.div`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
`;

const Heading = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  color: ${theme.colors.secondary900};
`;

const SectionHeading = ({ heading, tooltipOption, children }: IProps) => (
  <Container>
    <HeadingContainer>
      <Heading>{heading}</Heading>
      {tooltipOption && <InformationalTooltip tooltipOption={tooltipOption} />}
    </HeadingContainer>
    {children}
  </Container>
);

export default SectionHeading;
